import { render } from "./Home.vue?vue&type=template&id=57c9e86f&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=57c9e86f&scoped=true&lang=css"

import exportComponent from "/opt/md_star/md_star_client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c9e86f"]])

export default __exports__